import React, { Component } from "react"
import PropTypes from "prop-types"
import { Portal } from "react-portal"
import { Radium } from "higher-order-components"
import { childParser } from "containers/utilities"
import { CloseButton } from "components"
import { Body } from "containers"
import { getScrollTop } from "utils"

/** Overlay Component. */
export class Overlay extends Component {
  constructor(props) {
    super(props)
    this.handleKey = this.handleKey.bind(this)
  }

  componentDidMount() {
    this.scrollY = getScrollTop()
    Body.lock()
  }

  componentWillUnmount() {
    Body.unlock(this.scrollY)
  }

  /**
   * @param {object} event - keyDown event
   */
  handleKey(event) {
    if (event.key === "Escape") this.props.close(event)
  }

  /**
   * @param {Array|FlexContent} components - Nested Components
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <div id="Overlay" data-test="overlay" style={[styles.base]} onKeyDown={this.handleKey}>
        <div style={{
          background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))",
          position: "absolute",
          height: "75px",
          width: "100%",
          zIndex: "20"
        }}>
          <CloseButton dataTest="overlay-close" onClick={this.props.close} styleName={CloseButton.STYLE_NAMES.LIGHT} />
        </div>
        {childParser(this.props)}
      </div>
    )
  }
}

Overlay.propTypes = {
  components: PropTypes.array,
  close: PropTypes.func
}

export default Radium(Overlay)

// TODO
// fix animations

const styles = {
  base: {
    left: 0,
    top: 0,
    right: 0,
    height: "100%",
    overflowY: "auto",
    display: "flex",
    zIndex: 60,
    WebkitOverflowScrolling: "touch",
    position: "fixed",
    transition: "opacity .5s",
    backgroundColor: "#f5f5f5"
  }
}



// WEBPACK FOOTER //
// ./src/containers/overlay/index.jsx